import ReactDOM from "react-dom";
import axios from 'axios';
import './styles/globals.css'
import Demosite from './websites/Demosite';

axios.defaults.baseURL = "";
axios.defaults.baseURL = "https://api-queue-management-admin.nknu.edu.tw";


ReactDOM.render(
	    <>
	        <Demosite />
	    </>,
	    document.getElementById('root')
);





